export default __webpack_public_path__ + "static/media/green_dot.b5fcd1ca.svg";